var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D4D4D4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4854 10C13.351 10 9.99939 13.2216 9.99939 17.1952C9.99939 21.1688 13.351 24.3908 17.4854 24.3908C21.6199 24.3908 24.9711 21.1692 24.9711 17.1952C24.9711 13.2212 21.6199 10 17.4854 10ZM17.4854 22.266C14.5766 22.266 12.21 19.9912 12.21 17.1952C12.21 14.3992 14.5766 12.1244 17.4854 12.1244C20.3943 12.1244 22.7609 14.3992 22.7609 17.1952C22.7609 19.9912 20.3943 22.266 17.4854 22.266Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4857 15.6112C16.5756 15.6112 15.8378 16.3204 15.8378 17.1956C15.8378 18.0708 16.5756 18.7796 17.4857 18.7796C18.3958 18.7796 19.1336 18.0704 19.1336 17.1956C19.1336 16.3208 18.3958 15.6112 17.4857 15.6112ZM17.4857 18.7668C16.5843 18.7668 15.8507 18.062 15.8507 17.1952C15.8507 16.3284 16.5843 15.624 17.4857 15.624C18.3871 15.624 19.1203 16.3288 19.1203 17.1952C19.1203 18.0616 18.3871 18.7668 17.4857 18.7668Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.486 13.8744C15.5809 13.8744 14.0308 15.364 14.0308 17.1952C14.0308 19.0264 15.5809 20.5164 17.486 20.5164C19.3911 20.5164 20.9413 19.0264 20.9413 17.1952C20.9413 15.364 19.3911 13.8744 17.486 13.8744ZM17.486 18.7796C16.5759 18.7796 15.8381 18.0704 15.8381 17.1956C15.8381 16.3208 16.5759 15.6112 17.486 15.6112C18.3961 15.6112 19.134 16.3204 19.134 17.1956C19.134 18.0708 18.3961 18.7796 17.486 18.7796Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9462 22.1176L24.4061 23.3808L23.2554 24.6084L21.6212 23.1936",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2556 24.6084L22.9735 24.9092C22.5311 25.3812 22.5706 26.1084 23.0617 26.5332L26.4945 29.5052C27.3159 30.2164 28.5819 30.1528 29.3222 29.3632L29.4208 29.258C30.2531 28.37 30.1786 27.0012 29.2548 26.2016L25.5906 23.0292C25.3297 22.8032 24.9277 22.8236 24.693 23.0744L24.4062 23.3804",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveGlass);
export default __webpack_public_path__ + "static/media/InactiveGlass.0d92969491d4375935047ecb524fa5ba.svg";
export { ForwardRef as ReactComponent };